module.exports = __webpack_public_path__ + "static/search-umd-702b358998eb21cfb527838b5e640308.jpg";